import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import TextField from "@material-ui/core/TextField";
import { Grid } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import useQueues from "../../hooks/useQueues";
import UserStatusIcon from "../UserModal/statusIcon";
import ChatiaDialog from "../ChatiaDialog";

const TransferTicketModalCustom = ({ modalOpen, onClose, ticketid, ticket }) => {
  const history = useHistory();
  const [users, setUsers] = useState([]);
  const [queues, setQueues] = useState([]);
  const [allQueues, setAllQueues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedQueue, setSelectedQueue] = useState("");
  const { findAll: findAllQueues } = useQueues();
  const isMounted = useRef(true);
  const [msgTransfer, setMsgTransfer] = useState('');
  // classes removidas — não há mais selectMenu; Autocomplete herda estilo global do dialogPaper

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!modalOpen) return;
    const loadData = async () => {
      try {
        const queueList = await findAllQueues();
        if (isMounted.current) {
          setAllQueues(queueList);
          setQueues(queueList);
        }
        const { data } = await api.get("/users/", { params: { searchParam: "" } });
        if (isMounted.current) {
          setUsers(data.users || []);
        }
      } catch (err) {
        toastError(err);
      }
    };
    loadData();
  }, [modalOpen]);

  const handleUserChange = (_e, option) => {
    const userId = option ? option.id : "";
    setSelectedUser(userId);
    if (userId) {
      const user = users.find(u => u.id === userId);
      if (user && Array.isArray(user.queues)) {
        if (user.queues.length === 1) {
          setSelectedQueue(user.queues[0].id);
        }
        setQueues(user.queues);
      } else {
        setQueues(allQueues);
        setSelectedQueue("");
      }
    } else {
      setQueues(allQueues);
      setSelectedQueue("");
    }
  };

  const handleClose = () => {
    onClose();
    setSelectedUser("");
    setSelectedQueue("");
    setMsgTransfer("");
  };

  const handleSaveTicket = async () => {
    if (!ticketid) return;
    if (!selectedQueue || selectedQueue === "") return;
    setLoading(true);
    try {
      let data = {};
      data.userId = selectedUser || null;
      data.status = !selectedUser ? "pending" : ticket.isGroup ? "group" : "open";
      data.queueId = selectedQueue;
      data.msgTransfer = msgTransfer ? msgTransfer : null;
      data.isTransfered = true;

      await api.put(`/tickets/${ticketid}`, data);
      setLoading(false);
      history.push(`/tickets/`);
      handleClose();
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
  };

  return (
    <ChatiaDialog
      open={modalOpen}
      onClose={handleClose}
      title={i18n.t("transferTicketModal.title")}
      maxWidth="md"
      onSave={handleSaveTicket}
      saveText={i18n.t("transferTicketModal.buttons.ok")}
      saveDisabled={selectedQueue === ""}
      saveLoading={loading}
      saveType="button"
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            size="small"
            options={users}
            value={users.find((u) => u.id === selectedUser) || null}
            onChange={handleUserChange}
            getOptionLabel={(option) => option?.name || ""}
            getOptionSelected={(option, val) => option?.id === val?.id}
            renderOption={(option) => (
              <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <UserStatusIcon user={option} />
                {option.name}
              </span>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder={i18n.t("transferTicketModal.fieldLabel")}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            size="small"
            options={queues}
            value={queues.find((q) => q.id === selectedQueue) || null}
            onChange={(_e, opt) => setSelectedQueue(opt ? opt.id : "")}
            getOptionLabel={(option) => option?.name || ""}
            getOptionSelected={(option, val) => option?.id === val?.id}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder={i18n.t("transferTicketModal.fieldQueueLabel")}
              />
            )}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            label={i18n.t("transferTicketModal.msgTransfer")}
            value={msgTransfer}
            onChange={(e) => setMsgTransfer(e.target.value)}
            variant="outlined"
            multiline
            maxRows={5}
            minRows={5}
            fullWidth
          />
        </Grid>
      </Grid>
    </ChatiaDialog>
  );
};

export default TransferTicketModalCustom;
